import { render, staticRenderFns } from "./FrzPackingGroup.vue?vue&type=template&id=0e05348f"
import script from "./FrzPackingGroup.vue?vue&type=script&lang=js"
export * from "./FrzPackingGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports